import { Component } from 'react';

import { Button } from '@/shared/ui/Button';

export class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="grid min-h-screen place-items-center p-6">
          <div className="max-w-md text-center">
            <h1 className="text-2xl font-bold">Something went wrong</h1>
            <p className="mt-2 text-[var(--app-muted)]">Try reloading the page to recover.</p>
            <Button className="mt-5" onClick={() => window.location.reload()}>
              Reload page
            </Button>
          </div>
        </main>
      );
    }
    return this.props.children;
  }
}
